import { TENDER_STATUS_LABELS, type TenderStatus } from '@nova/shared';
import {
  Ban,
  CircleDot,
  FileText,
  PackageCheck,
  Search,
  ThumbsDown,
  ThumbsUp,
  Trophy,
} from 'lucide-react';
import { cn } from '../../lib/cn.js';

interface Tone {
  className: string;
  Icon: typeof CircleDot;
}

/** One consistent colour + icon per tender status (06-designsystem.md). */
const TONES: Record<TenderStatus, Tone> = {
  NY: { className: 'bg-accent/12 text-accent border-accent/25', Icon: CircleDot },
  VURDERES: { className: 'bg-violet/12 text-violet border-violet/25', Icon: Search },
  BID: { className: 'bg-success/12 text-success border-success/25', Icon: ThumbsUp },
  NO_BID: { className: 'bg-ink-soft/12 text-ink-soft border-ink-soft/25', Icon: ThumbsDown },
  UNDER_ARBEID: { className: 'bg-warning/12 text-warning border-warning/25', Icon: FileText },
  LEVERT: { className: 'bg-accent/12 text-accent border-accent/25', Icon: PackageCheck },
  VUNNET: { className: 'bg-success/18 text-success border-success/35', Icon: Trophy },
  TAPT: { className: 'bg-danger/12 text-danger border-danger/25', Icon: ThumbsDown },
  AVLYST: { className: 'bg-ink-soft/8 text-ink-soft border-ink-soft/20', Icon: Ban },
};

export function TenderStatusBadge({
  status,
  size = 'md',
}: {
  status: TenderStatus;
  size?: 'sm' | 'md';
}) {
  const tone = TONES[status];
  const { Icon } = tone;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border font-medium',
        tone.className,
        size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs',
      )}
    >
      <Icon size={size === 'sm' ? 11 : 13} aria-hidden />
      {TENDER_STATUS_LABELS[status]}
    </span>
  );
}
